// Read helpers for the in-code blog. Pure (no Vite or React APIs) so /api can import it.

import { BLOG_POSTS, type BlogPostMeta } from '../content/blog/posts.js';

export type { BlogPostMeta };

export const BLOG_SITE = 'https://beatview.ai';

const byNewest = (a: BlogPostMeta, b: BlogPostMeta) => b.publishedAt.localeCompare(a.publishedAt);

export const getPublishedPosts = (): BlogPostMeta[] => [...BLOG_POSTS].sort(byNewest);

export const getPostBySlug = (slug: string): BlogPostMeta | undefined => BLOG_POSTS.find(p => p.slug === slug);

export const getPostsByCategory = (category: string): BlogPostMeta[] => getPublishedPosts().filter(p => p.category === category);

/** Hand-picked related posts first, then the newest posts in the same category. */
export const getRelatedPosts = (post: BlogPostMeta, limit = 3): BlogPostMeta[] => {
  const picked = (post.related ?? []).map(getPostBySlug).filter((p): p is BlogPostMeta => !!p);
  const sameCategory = getPostsByCategory(post.category).filter(p => p.slug !== post.slug && !picked.includes(p));
  return [...picked, ...sameCategory].slice(0, limit);
};

/** SEO title without a trailing "| Beatview", so pages can append the brand once. */
export const postSeoTitle = (post: BlogPostMeta) => post.seoTitle.replace(/\s*[|–—-]\s*Beatview\s*$/i, '');

export const absoluteUrl = (path: string) => (path.startsWith('http') ? path : `${BLOG_SITE}${path}`);
